const isDev = process.env.NODE_ENV === 'development';

export function p2Log(tag, payload) {
  if (!isDev) return;
  console.log(tag, payload);
}

export function p2LogSnap({ applied, version, reason, position, isPlaying, songId, why }) {
  p2Log('[p2-snap]', {
    applied: applied ? 'applied' : 'ignored',
    version,
    reason: reason ?? null,
    position: position ?? null,
    isPlaying: Boolean(isPlaying),
    songId: songId ?? null,
    ...(why ? { why } : {}),
  });
}
